<template>
	<div class="cartcell">
		<div class="cartcell-left">
			<img @click="review_good" class="cover" :src="img" alt="" />
		</div>
		<div class="cartcell-middle" @click="review_good">
			<span class="title">{{good.name_lang}}</span>
			<span class="info">{{good.info_lang}}</span>
			<span class="price">RMB: {{good.price}}</span>
		</div>
		<photos-viewer :visible="show_photo_viewer" :imgs="imgs" @show="hidden_photo_viewer"></photos-viewer>
	</div>
</template>

<script>
import { baseURL } from '../../api/api'

import {  str_to_array } from '../../utils'
import PhotosViewer from '../../components/photosviewer'
	export default {
		name:'cart-show-cell',
		components:{
			PhotosViewer
		},
		props:{
			good:{
				type:Object,
				default:null
			}
		},
		data() {
			return {
				baseURL,
	
				show_photo_viewer:false
			}
		},
		computed: {
			img() {
				if(this.good.cover.startsWith('/')){
					return `${this.baseURL}${this.good.cover}?q=30`
				}
				return `${this.baseURL}/${this.good.cover}?q=30`
			},
			imgs(){
				var imgs = []
				str_to_array(this.good.pics).map(pic=>{
					imgs.push(pic.startsWith('/')?`${baseURL}${pic}`:`${baseURL}/${pic}`)
				})
				return imgs 
			}
		},
		methods: {
			delete_good() {
			
				this.$emit('deletelike',this.good)
				
				
			},
			review_good(){
				// this.show_photo_viewer = true
				this.$emit('review_photos',this.good)
				console.log('review_good')
			},
			hidden_photo_viewer(){
				this.show_photo_viewer = false
			}
		},
	}
</script>

<style lang="less">
	page{
		background-color: #F6F1EB;
	}
	.cartcell{
		background-color: #FFFCF7;
		display: flex;
		align-items: center;
		position: relative;
		padding: 2px 5px;
		.cartcell-left{
			display: flex;
			align-items: center;
			justify-content: center;
			height: 100%;
			.cover{
				width: 50px;
				height: 50px;
				object-fit: cover;
			}
		}
		
		.cartcell-middle{
			display: flex;
			flex-direction: column;
			justify-content: left;
			text-align: left;
			padding: 2px 20px;
			margin-right: 10px;
			.title{
				color: #444;
				font-size: var(--font-size-title-small);
				line-height: 1.5rem;
				font-family: var(--font-title);
				word-wrap: break-word;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				word-break: break-word;
				display: -webkit-box;
			}
			.info{
				background-color: #FFFCF7;
				font-size: 12px;
				word-wrap: break-word;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				word-break: break-word;
				display: -webkit-box;
				// margin-top: 10px;
			}
			.price{
				margin-top:2px;
				color: #696969;
				font-size: var(--font-size-text-large);
				font-family: var(--font-body);
			}
		}
		.right{
			position: absolute;
			right: 10px;
			.iconfont{
				cursor: pointer;
			}
		}
	}
</style>